import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../css/header.css';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default function Header({type = 1, uptitle, children, morehref="", moretitle=""}) {
        
    const Tag = `h${type}`;

    return (
        
        <div className="header-section">
            <div className="left-side">
                <span>{uptitle}</span>
                <Tag> {children} </Tag>
            </div>
            {morehref.length > 0 ? 
                <div className="right-side">
                    <a className="show-more-header-button" href={morehref} title={moretitle}>{moretitle}</a> <FontAwesomeIcon className="header-more-icon" icon={faArrowRight} />
                </div>
             : ``}
            
        </div>
        
    )
}